import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Breadcrumbs from '../../layout/Breadcrumbs';

// Swiper React components & modules
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

// Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';

function Testimonials({ showBreadcrumbs = true }) {
  // Initialize AOS if you use Animate On Scroll
  useEffect(() => {
    AOS.init({
      duration: 1000,
      offset: 50,
      easing: 'ease-in-out',
      once: false,
    });
  }, []);

  return (
    <>
      {/* Conditionally render Breadcrumbs */}
      {showBreadcrumbs && (
        <Breadcrumbs
          pageTitle="Testimonials"
          pageSubtitle="Inspiring Feedback by Our Clients"
          activePage="Testimonials"
        />
      )}
    <section id="testimonials" className="testimonials">
      <div className="container" data-aos="fade-up">
        {/* Swiper Component */}
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          navigation               // Enables next/prev arrows
          pagination={{ clickable: true }}
          autoplay={{
            delay: 15000,
            disableOnInteraction: false,
          }}
          loop={true}
          slidesPerView={1}
          spaceBetween={10}
          className="my-swiper"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          {/* Slide 1 */}
          <SwiperSlide>
            <img
              src="./assets/images/testimonials/testimonials-01.png"
              alt="Client"
              className="testimonial-img"
            />
          </SwiperSlide>

          {/* Slide 2 */}
          <SwiperSlide>
            <img
              src="./assets/images/testimonials/testimonials-02.png"
              alt="Client"
            />
          </SwiperSlide>

          {/* Slide 3 */}
          <SwiperSlide>
            <img
              src="./assets/images/testimonials/testimonials-03.png"
              alt="Client"
            />
          </SwiperSlide>

          {/* Slide 4 */}
          <SwiperSlide>
            <img
              src="./assets/images/testimonials/testimonials-04.png"
              alt="Client"
            />
          </SwiperSlide>

          {/* Slide 5 */}
          <SwiperSlide>
            <img
              src="./assets/images/testimonials/testimonials-05.png"
              alt="Client"
            />
          </SwiperSlide>

          {/* Slide 6 */}
          <SwiperSlide>
            <img
              src="./assets/images/testimonials/testimonials-06.png"
              alt="Client"
            />
          </SwiperSlide>
        </Swiper>
      </div>
    </section>
    </>
  );
}

export default Testimonials;
